import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = {
  key: 0,
  class: "mb-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SeqNoticeCard = _resolveComponent("SeqNoticeCard")

  return (_ctx.isShowPMAWarning)
    ? (_openBlock(), _createBlock(_component_SeqNoticeCard, {
        key: 0,
        variant: "warning",
        title: 'PMA Reminder for ' + _ctx.userUsid,
        buttons: _ctx.pmaReminderButtons,
        "enable-move-controls": true,
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _createVNode("p", _hoisted_1, _toDisplayString(_ctx.unilevelMaintenancePromptMessage1) + " " + _toDisplayString(_ctx.unilevelMaintenancePromptMessage2), 1),
          (_ctx.extraPromptMessage)
            ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.extraPromptMessage), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title", "buttons"]))
    : _createCommentVNode("", true)
}